export type NormalizedTier = 'resident' | 'associate';

export type RawTier = string | null | undefined;

/**
 * Normalize any tier-ish string to the product's two-way split.
 *
 * Accepts both:
 *   - Product tier labels: `resident` / `associate` (+ legacy `intern`,
 *     which is a historical alias for `resident` carried from pre-
 *     rebrand quiz answers and therapist-facing copy).
 *   - DB `pros.employmentStatus` values: `RESIDENT` | `EMPLOYEE` |
 *     `CONTRACTOR` | `SUPERVISOR` (and anything else). The product
 *     policy is "RESIDENT is resident, everything else is associate" —
 *     employees, contractors, and supervisors all bill at the
 *     associate sliding scale.
 *
 * Null/undefined/empty inputs default to `resident` — the cheaper
 * sliding scale, matching the historical behavior. Downstream callers
 * that need to distinguish "no tier known" from "resident" should check
 * the raw value before normalizing.
 */
export function normalizeTier(raw: RawTier): NormalizedTier {
  if (!raw) return 'resident';
  const t = raw.toUpperCase();
  if (t === 'RESIDENT' || t === 'INTERN') return 'resident';
  return 'associate';
}
